'use client';

import React from 'react';

import { type AppbarProps } from './appbar.component';
import DesktopAppbar from './desktop-appbar.component';
import MobileAppbar from './mobile-appbar.component';

export interface ResponsiveAppbarProps {
  className?: string;
  appbar?: AppbarProps;
  appbarType?: string;
}

export default function ResponsiveAppbar({
  className = '',
  appbar,
  appbarType = 'both',
}: ResponsiveAppbarProps) {
  return (
    <div className={`w-full ${className}`}>
      {(appbarType === 'both' || appbarType === 'desktop') && (
        <DesktopAppbar {...appbar} />
      )}
      {(appbarType === 'both' || appbarType === 'mobile') && (
        <MobileAppbar {...appbar} />
      )}
    </div>
  );
}
